import React from "react";
import { Box, TextField, Alert, Autocomplete } from "@mui/material";
import Langs from "../../../../../app/lang/langs";
import { INPUT_SX } from "../constants";
import FieldRow from "./FieldRow";

export default function AddUserBody({
  availableCollabs,
  selectedCollabs,
  formError,
  handleCollabsChange,
}) {
  return (
    <Box sx={{ px: 2.5, pt: 2, pb: 12 }}>
      <FieldRow label="COLLABS" error={formError === "MISSING_COLLABS"}>
        <Autocomplete
          multiple
          options={availableCollabs}
          getOptionLabel={(opt) => opt.label || ""}
          value={selectedCollabs}
          onChange={(_e, newVal) => handleCollabsChange(newVal)}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              error={formError === "MISSING_COLLABS"}
              sx={INPUT_SX}
              inputProps={{
                ...params.inputProps,
                style: { fontSize: "16px" },
              }}
            />
          )}
          sx={{
            "& .MuiAutocomplete-tag": {
              borderRadius: "8px",
              fontSize: "0.8rem",
            },
          }}
          slotProps={{
            popper: { sx: { zIndex: 1500 } },
          }}
        />
      </FieldRow>

      {/* Error */}
      {formError && (
        <Alert severity="error" sx={{ mt: 2, borderRadius: "12px", fontSize: "0.85rem" }}>
          <Langs str={formError} />
        </Alert>
      )}
    </Box>
  );
}
